import { render, staticRenderFns } from "./xqqx.vue?vue&type=template&id=1ea8cbdd&scoped=true"
import script from "./xqqx.vue?vue&type=script&lang=js"
export * from "./xqqx.vue?vue&type=script&lang=js"
import style0 from "./xqqx.vue?vue&type=style&index=0&id=1ea8cbdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8cbdd",
  null
  
)

export default component.exports